import { instance } from '@/services/avik-api-gateway'
import { VehicleTypePeriod } from '@/types/vehicle-type-period'
import { AxiosResponse } from 'axios'

export function createVehicleTypePeriod(
  body: VehicleTypePeriod
): Promise<AxiosResponse<VehicleTypePeriod>> {
  return instance.post(`/vehicle-type-period`, body)
}
